import api from '../utils/api';
import { LicState } from '../types';

// Gets all possible license states from the database
export const getAllLicStates = async (): Promise<LicState[]> => {
  const res = await api.get('/api/states');
  return res.data;
};

// Gets the specific states associated with a user
export const getStatesForUser = async (userId: string): Promise<LicState[]> => {
  const res = await api.get(`/api/states/user/${userId}`);
  return res.data;
};

// Adds a state to a user's profile
export const addStateToUser = async (_userId: string, stateID: number): Promise<any> => {
  // Backend identifies user from JWT; prefer numeric stateID as many APIs expect this
  const res = await api.post(`/api/users/states`, { stateID });
  return res.data;
};